import React from 'react';
import Logger from '../../../../../common/logger';
import CloseIcon from '../../../../common/icons/close-slim.svg';
import Cookies from '../../../../../common/Cookies';
import './style.scss';
import * as MainActions from '../../../main/actions';
import { LAYERS } from '../../../layers/types';

class ContactTip extends React.Component {
    constructor(props) {
        super(props);
        const { layerConfig, viewConfig } = this.props,
            delay = layerConfig.isInitView ? parseInt(viewConfig.showAfter) : 0;
        this.showAfter = layerConfig.isInitView
            ? delay + parseInt(viewConfig.tipOptions.showAfter)
            : -1;
        this.hideAfter = layerConfig.isInitView
            ? delay + parseInt(viewConfig.tipOptions.hideAfter)
            : -1;
        this.componentTimeout = null;
        this.state = {
            visibility: 'hidden'
        };
    }

    componentDidMount() {
        if (!this.isCookiePresent()) {
            if (this.showAfter > 0) {
                this.componentTimeout = setTimeout(() => this.show(), this.showAfter * 1000);
            } else {
                this.show();
            }
        }
    }

    componentWillUnmount() {
        this.setState({ visibility: 'hidden' });
        clearTimeout(this.componentTimeout);
    }

    show() {
        this.setState({ visibility: 'visible' });
        if (this.hideAfter > 0) {
            this.componentTimeout = setTimeout(() => this.hide(), this.hideAfter * 1000);
        }
        this.updateMainLayer();
    }

    hide() {
        this.setState({ visibility: 'hidden' });
        this.updateMainLayer();
    }

    close() {
        clearTimeout(this.componentTimeout);
        this.hide();
        this.saveCookie();
    }

    updateMainLayer() {
        setTimeout(
            () =>
                MainActions.updateMainLayer({
                    layer: LAYERS.WIDGET
                }),
            200
        );
    }

    isCookiePresent() {
        const cookieName = Cookies.getItem(this.props.options.default.cookies.WIDGET_TIP_COOKIE);
        Logger.log('Cookie: ' + cookieName);
        return cookieName;
    }

    saveCookie() {
        Cookies.setItem(this.props.options.default.cookies.WIDGET_TIP_COOKIE, 'true');
    }

    render() {
        const { viewConfig } = this.props;
        if (viewConfig.tipOptions.tipText && this.state.visibility == 'visible') {
            return (
                <div className={this.state.visibility + ' contact-tip'}>
                    <span title="Zamknij" onClick={() => this.close()} className="icon icon-close">
                        <CloseIcon />
                    </span>
                    <div
                        className="content"
                        dangerouslySetInnerHTML={{
                            __html: viewConfig.tipOptions.tipText
                        }}
                    />
                    <div className="pointer" />
                </div>
            );
        } else {
            return null;
        }
    }
}

export default ContactTip;
